<template>
    <div>
        <div class="filter">
            <h2>Find A Presentation</h2>
            <search-filter @searchChanged="updateSearch"></search-filter>

            <div class="library-filters">
                <year-filter :years="years"  @yearsChanged="updateYears"></year-filter>
                <chapter-filter :chapters="chapters" @chaptersChanged="updateChapters" :name-for-global="nameForGlobal" ></chapter-filter>
                <category-filter :categories="categories" @categoriesChanged="updateCategories" ></category-filter>
            </div>

        </div>
        <div class="library-list" :class="{'hideResults':hideResults}">

            <results-count :item-count="itemsCount"></results-count>

            <library-list :items="itemsToShow" :loading="loading"></library-list>

            <nav class="icota_pagination">
                <v-pagination v-if="totalPages && totalPages!=1 && !loading" v-model="currentPage" :page-count="totalPages" :classes="paginationClasses" :labels="paginationAnchorTexts" @change="updateItemsToShow(true)">
                </v-pagination>
            </nav>
        </div>
    </div>
</template>

<script>
import vPagination from 'vue-plain-pagination';
import { DateTime } from 'luxon';

export default {

    props: ['chapters', 'years', 'categories'],

    data() {

        return {
            nameForGlobal: 'Global',
            chaptersSelected: [],
            yearsSelected: [],
            categoriesSelected: [],
            search: '',
            hideResults: true,
            loading: false,
            itemsPerPage: 24,
            itemsCount: 0,
            allItems: [],
            itemsToShow: [],
            meta: [],
            cancel: null,
            currentPage: 1,
            totalPages: 1,
            totalItems: 0,
            paginationClasses: {
                ul: 'pagination__list',
                li: 'pagination__group',
                liDisable: 'disabled',
                button: 'pagination__item',
                buttonActive: 'pagination__item_active',
            },
            paginationAnchorTexts: {
                first: 'First',
                prev: ' Prev',
                next: 'Next',
                last: 'Last'
            },
        }
    },


    components: {
        vPagination
    },

    mounted() {

        const query =
            `{
                entries(section: "library") {
                    ... on library_library_Entry {
                    id
                    eventLocation
                    startDate
                    endDate
                    title
                    chapters {
                        id
                    }
                    libraryCategory {
                        id
                    }
                    eventDetails {
                        ...eventDetails
                    }
                    }
                }
                }

                fragment eventDetails on eventDetails_MatrixField {
                ... on eventDetails_header_BlockType {
                    typeHandle
                    sectionHeader
                    headerContent
                    id
                }
                ... on eventDetails_paperPresentation_BlockType {
                    typeHandle
                    libraryTitle
                    libraryAuthors
                    libraryAttachment {
                    id
                    url
                    }
                }
            }`;


        window.axios.post('/api', {query: query}, {headers: {Authorization: window.libraryToken}})
        .then(response => {
            this.allItems = response.data.data.entries.sort((a,b)=>{
                const first = DateTime.fromISO(a.startDate)
                const second = DateTime.fromISO(b.startDate)
                return first < second ? 1 : first > second ? -1 : 0;
                });
            this.updateItemsToShow(false);
            this.hideResults = false;
            this.showSpinner = false;
        });

    },

    methods: {

         updateCategories(categories) {
             this.currentPage = 1;
             this.categoriesSelected = categories;
             this.updateItemsToShow(false);
         },
         updateChapters(chapters) {
             this.currentPage = 1;
             this.chaptersSelected = chapters;
             this.updateItemsToShow(false);
         },
         updateYears(years) {
             this.currentPage = 1;
             this.yearsSelected = years;
             this.updateItemsToShow(false);
         },
         updateSearch(search) {
            this.currentPage = 1;
            this.search = search;
            this.updateItemsToShow(false);
         },
         updateItemsToShow(fromPagination){
             if (fromPagination) {
                document.querySelector('.library-list').scrollIntoView({
                  behavior: "smooth"
                });
              }

              var potentialItemsToShow = this.allItems;

              if (this.chaptersSelected.length) {
                potentialItemsToShow = potentialItemsToShow.filter((item)=>{
                   var itemChapters = [0];
                   if (item.chapters.length) {
                      itemChapters = item.chapters.map(chapter=>parseInt(chapter.id))
                    }
                   return itemChapters.some(r=> this.chaptersSelected.map(chapter=>parseInt(chapter)).includes(r))
                });
              }

              if (this.categoriesSelected.length) {
                potentialItemsToShow = potentialItemsToShow.filter((item)=>{
                    return item.libraryCategory.map(category=>category.id).some(r=>this.categoriesSelected.includes(parseInt(r)));
                });
              }


              if (this.yearsSelected.length) {
                potentialItemsToShow = potentialItemsToShow.filter((item)=>{
                  const itemYear = parseInt(item.startDate.substr(0,4));
                  return this.yearsSelected.includes(itemYear);
                });
              }

             // search terms
              if (this.search.length) {
                potentialItemsToShow = potentialItemsToShow.filter((item)=>{
                    const thingsToSearch = [
                        item.title,
                        ...item.eventDetails.map(details=>details.libraryTitle),
                        ...item.eventDetails.map(details=>details.libraryAuthors),
                    ]
                    return thingsToSearch.join().toLowerCase().includes(this.search.toLowerCase());
                });
              }


              this.totalPages = Math.ceil(potentialItemsToShow.length/this.itemsPerPage);

              const startAt = (this.currentPage*this.itemsPerPage)-this.itemsPerPage;
              const endAt = this.currentPage*this.itemsPerPage;

              this.itemsCount = potentialItemsToShow.length;
              this.itemsToShow = potentialItemsToShow.slice(startAt,endAt);


         }


    }
}
</script>
